import { useState, useEffect } from "react";
import { Row, Col, Drawer } from "antd";
import Container from "../../common/Container";
import { Image } from "../../common/Image";
import { Button } from "../../common/Button";
import { useTranslation } from "../../contexts/LanguageContext";
import {
  HeaderSection,
  LogoContainer,
  Burger,
  NotHidden,
  Menu,
  CustomNavLinkSmall,
  Label,
  Outline,
  Span,
} from "./styles";

const Header = () => {
  const t = useTranslation();

  const [visible, setVisibility] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;

    const onScroll = (e: Event) => {
      const t = e.target as Element | Document;
      const y =
        window.scrollY ||
        document.documentElement.scrollTop ||
        document.body.scrollTop ||
        ((t as Element)?.scrollTop ?? 0) ||
        0;
      setIsScrolled(y > 50);
    };

    onScroll({ target: document } as any);
    document.addEventListener("scroll", onScroll, { passive: true, capture: true });
    return () => document.removeEventListener("scroll", onScroll, true);
  }, []);


  const toggleButton = () => setVisibility(!visible);

  const scrollTo = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
    setVisibility(false);
  };


  const MenuItem = () => (
    <>
      <CustomNavLinkSmall onClick={() => scrollTo("about")}>
        <Span>{t.common.about}</Span>
      </CustomNavLinkSmall>
      <CustomNavLinkSmall onClick={() => scrollTo("devices")}>
        <Span>{t.common.solutions}</Span>
      </CustomNavLinkSmall>
      <CustomNavLinkSmall onClick={() => scrollTo("other-services")}>
        <Span>{t.common.otherServices}</Span>
      </CustomNavLinkSmall>
      <CustomNavLinkSmall style={{ width: "180px" }} onClick={() => scrollTo("contact")}>
        <Span>
          <Button>{t.common.contact}</Button>
        </Span>
      </CustomNavLinkSmall>
    </>
  );

  return (
    <HeaderSection $isScrolled={isScrolled}>
      <Container>
        <Row justify="space-between">
          <LogoContainer to="/" aria-label="homepage">
            <Image src="svg/logo.png" height="40px" />
          </LogoContainer>
          <NotHidden>
            <MenuItem />
          </NotHidden>
          <Burger onClick={toggleButton}>
            <Outline />
          </Burger>
        </Row>
        <Drawer closable={false} open={visible} onClose={toggleButton}>
          <Col style={{ marginBottom: "2.5rem" }}>
            <Label onClick={toggleButton}>
              <Col span={12}><Menu>Menu</Menu></Col>
              <Col span={12}><Outline /></Col>
            </Label>
          </Col>
          <MenuItem />
        </Drawer>
      </Container>
    </HeaderSection>
  );
};

export default Header;
